import { type PropsWithChildren } from "react";
import Button, { type LinkButton } from "@/components/common/Button";
import CallToActionGroup from "@/components/site-builder/CallToActionGroup";
import { useTranslation } from "@/i18n/client";
import { getUploadedFileURL } from "@/utils/url/getUploadedFileURL";
import s from "./DownloadButton.module.scss";

export type DownloadButtonProps = Omit<LinkButton, "href" | "extendedURI"> & {
  fileName: string;
};

export default function DownloadButton(
  props: PropsWithChildren<DownloadButtonProps>,
) {
  const { fileName, children, ...buttonProps } = props;
  const { t } = useTranslation("site-builder");

  return (
    <CallToActionGroup className={s.wrapper}>
      <Button
        href={getUploadedFileURL(fileName)}
        extendedURI={false}
        {...buttonProps}
      >
        {children || t("module.file-download.cta.download-file.label")}
      </Button>
    </CallToActionGroup>
  );
}
